import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../geometry.js";
import e from "../../core/Error.js";
import { convertUnit as t } from "../../core/unitUtils.js";
import { toRadians as n, spheroids as i, WKT_SPHEROID_REGEX as s } from "./geodesicConstants.js";
import a from "../Polyline.js";
import r from "../Polygon.js";
import o from "../Point.js";
import c from "../SpatialReference.js";

function l(e) {
  if (!e) return null;

  if (e.isGeographic && e.wkid) {
    var _t = i[e.wkid];
    if (_t) return _t;
  }

  if (e.wkt) {
    var _t2 = h(e.wkt);

    if (_t2) return _t2;
  }

  return null;
}

function h(e) {
  var t = s.exec(e);
  if (!t || 2 !== t.length) return null;
  var n = t[1].split(",");
  if (!n || n.length < 3) return null;
  var i = parseFloat(n[1]),
      a = parseFloat(n[2]);
  if (isNaN(i) || isNaN(a)) return null;
  return {
    a: i,
    f: 0 === a ? 0 : 1 / a
  };
}

function f(e) {
  var t = l(e || c.WGS84);
  if (p(t)) return t;
  var n = t.a * (1 - t.f);
  return Object.assign(t, {
    b: n,
    eSq: 1 - Math.pow(n / t.a, 2),
    radius: (2 * t.a + n) / 3,
    densificationRatio: 1e4 / ((2 * t.a + n) / 3)
  });
}

function p(e) {
  return "b" in e && "eSq" in e && "radius" in e;
}

function u(e) {
  return e < 0 ? e + 360 : e;
}

function d(e, t, i) {
  var _f = f(i),
      s = _f.a,
      a = _f.eSq,
      r = Math.sqrt(a),
      o = Math.sin(t[1] * n),
      c = s * t[0] * n;

  var l;

  if (a > 0) {
    l = s * ((1 - a) * (o / (1 - a * (o * o)) - 1 / (2 * r) * Math.log((1 - r * o) / (1 + r * o)))) * .5;
  } else l = s * o;

  return e[0] = c, e[1] = l, e;
}

function m(e) {
  return null !== l(e);
}

function g(n) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "square-meters";
  if (n.some(function (e) {
    return !m(e.spatialReference);
  })) throw new e("geodesic-areas:invalid-spatial-reference", "the input geometries spatial reference is not supported");
  var s = [];

  for (var _e = 0; _e < n.length; _e++) {
    var _t3 = n[_e],
        _i = _t3.spatialReference,
        _f2 = f(_i),
        _a = _f2.radius,
        _r = _f2.densificationRatio,
        _o = _a * _r;

    s.push(w(_t3, _o));
  }

  var a = [],
      r = [0, 0],
      o = [0, 0];

  for (var _e2 = 0; _e2 < s.length; _e2++) {
    var _s$_e = s[_e2],
        _n = _s$_e.rings,
        _c = _s$_e.spatialReference;
    var _l = 0;

    for (var _e3 = 0; _e3 < _n.length; _e3++) {
      var _t4 = _n[_e3];
      d(r, _t4[0], _c), d(o, _t4[_t4.length - 1], _c);

      var _i2 = o[0] * r[1] - r[0] * o[1];

      for (var _e4 = 0; _e4 < _t4.length - 1; _e4++) {
        d(r, _t4[_e4 + 1], _c), d(o, _t4[_e4], _c), _i2 += o[0] * r[1] - r[0] * o[1];
      }

      _l += _i2;
    }

    _l = t(_l, "square-meters", i), a.push(_l / -2);
  }

  return a;
}

function M(n) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "meters";
  if (!n) throw new e("geodesic-lengths:invalid-geometries", "the input geometries type is not supported");
  if (n.some(function (e) {
    return !m(e.spatialReference);
  })) throw new e("geodesic-lengths:invalid-spatial-reference", "the input geometries spatial reference is not supported");
  var s = [];

  for (var _e5 = 0; _e5 < n.length; _e5++) {
    var _a2 = n[_e5],
        _r2 = _a2.spatialReference,
        _o2 = "polyline" === _a2.type ? _a2.paths : _a2.rings;

    var _c2 = 0;

    for (var _e6 = 0; _e6 < _o2.length; _e6++) {
      var _t5 = _o2[_e6];
      var _n2 = 0;

      for (var _e7 = 1; _e7 < _t5.length; _e7++) {
        var _i3 = _t5[_e7 - 1][0],
            _s = _t5[_e7][0],
            _a3 = _t5[_e7 - 1][1],
            _o3 = _t5[_e7][1];

        if (_a3 !== _o3 || _i3 !== _s) {
          var _e8 = {
            distance: null
          };
          R(_e8, [_i3, _a3], [_s, _o3], _r2), _n2 += _e8.distance;
        }
      }

      _c2 += _n2;
    }

    _c2 = t(_c2, "meters", i), s.push(_c2);
  }

  return s;
}

function w(t, n) {
  if ("polyline" !== t.type && "polygon" !== t.type) throw new e("geodesic-densify:invalid-geometry", "the input geometry is neither polyline nor polygon");
  var i = t.spatialReference;
  if (!m(i)) throw new e("geodesic-densify:invalid-spatial-reference", "the input geometry spatial reference is not supported");
  var s = "polyline" === t.type ? t.paths : t.rings,
      o = [],
      c = [0, 0],
      l = {
    distance: null
  };

  var _iterator = _createForOfIteratorHelper(s),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _e9 = _step.value;
      var _t6 = [];
      o.push(_t6), _t6.push([_e9[0][0], _e9[0][1]]);

      var _s2 = void 0,
          _a4 = void 0,
          _r3 = _e9[0][0],
          _h = _e9[0][1];

      for (var _o4 = 0; _o4 < _e9.length - 1; _o4++) {
        if (_s2 = _e9[_o4 + 1][0], _a4 = _e9[_o4 + 1][1], _r3 === _s2 && _h === _a4) continue;
        var _f3 = [_r3, _h];
        R(l, [_r3, _h], [_s2, _a4], i);

        var _p = l.azimuth,
            _u = l.distance,
            _d = _u / n;

        if (_d > 1) {
          for (var _e10 = 1; _e10 <= _d - 1; _e10++) {
            y(c, _f3, _p, _e10 * n, i), _t6.push(c.slice(0));
          }

          y(c, _f3, _p, (_u + Math.floor(_d - 1) * n) / 2, i), _t6.push(c.slice(0));
        }

        y(c, _f3, _p, _u, i), _t6.push(c.slice(0)), _r3 = c[0], _h = c[1];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return "polyline" === t.type ? new a({
    paths: o,
    spatialReference: i
  }) : new r({
    rings: o,
    spatialReference: i
  });
}

function y(e, t, i, s, a) {
  var r = t[0],
      o = t[1],
      c = r * n,
      l = o * n,
      h = i * n,
      _f4 = f(a),
      p = _f4.a,
      u = _f4.b,
      d = _f4.f,
      m = Math.sin(h),
      g = Math.cos(h),
      M = (1 - d) * Math.tan(l),
      w = 1 / Math.sqrt(1 + M * M),
      y = M * w,
      R = Math.atan2(M, g),
      v = w * m,
      z = v * v,
      b = 1 - z,
      q = b * (p * p - u * u) / (u * u),
      j = 1 + q / 16384 * (4096 + q * (q * (320 - 175 * q) - 768)),
      x = q / 1024 * (256 + q * (q * (74 - 47 * q) - 128));

  var A,
      N,
      S,
      k,
      P = s / (u * j),
      F = 2 * Math.PI;

  for (; Math.abs(P - F) > 1e-12;) {
    S = Math.cos(2 * R + P), A = Math.sin(P), N = Math.cos(P), k = x * A * (S + x / 4 * (N * (2 * S * S - 1) - x / 6 * S * (4 * A * A - 3) * (4 * S * S - 3))), F = P, P = s / (u * j) + k;
  }

  var G = y * A - w * N * g,
      C = Math.atan2(y * N + w * A * g, (1 - d) * Math.sqrt(z + G * G)),
      E = Math.atan2(A * m, w * N - y * A * g),
      I = d / 16 * b * (4 + d * (4 - 3 * b)),
      O = C / n,
      U = (c + (E - (1 - I) * d * v * (P + I * A * (S + I * N * (2 * S * S - 1))))) / n;
  return e[0] = U, e[1] = O, e;
}

function R(e, t, i, s) {
  var a = t[0] * n,
      r = t[1] * n,
      o = i[0] * n,
      c = i[1] * n,
      _f5 = f(s),
      l = _f5.a,
      h = _f5.b,
      p = _f5.f,
      u = _f5.radius,
      d = o - a,
      m = Math.atan((1 - p) * Math.tan(r)),
      g = Math.atan((1 - p) * Math.tan(c)),
      M = Math.sin(m),
      w = Math.cos(m),
      y = Math.sin(g),
      R = Math.cos(g);

  var v,
      z,
      b,
      q,
      j,
      x,
      A,
      N,
      S,
      k,
      P = 1e3,
      F = d;

  do {
    if (A = Math.sin(F), N = Math.cos(F), b = Math.sqrt(R * A * (R * A) + (w * y - M * R * N) * (w * y - M * R * N)), 0 === b) return e.distance = 0, e.azimuth = void 0, e.reverseAzimuth = void 0, e;
    j = M * y + w * R * N, x = Math.atan2(b, j), S = w * R * A / b, z = 1 - S * S, q = j - 2 * M * y / z, isNaN(q) && (q = 0), k = p / 16 * z * (4 + p * (4 - 3 * z)), v = F, F = d + (1 - k) * p * S * (x + k * b * (q + k * j * (2 * q * q - 1)));
  } while (Math.abs(F - v) > 1e-12 && --P > 0);

  if (0 === P) {
    var _t7 = u,
        _i4 = Math.acos(Math.sin(r) * Math.sin(c) + Math.cos(r) * Math.cos(c) * Math.cos(o - a)) * _t7,
        _s3 = o - a,
        _l2 = Math.sin(_s3) * Math.cos(c),
        _h2 = Math.cos(r) * Math.sin(c) - Math.sin(r) * Math.cos(c) * Math.cos(_s3),
        _f6 = Math.atan2(_l2, _h2);

    return e.azimuth = _f6 / n, e.distance = _i4, e.reverseAzimuth = void 0, e;
  }

  var G = z * (l * l - h * h) / (h * h),
      C = G / 1024 * (256 + G * (G * (74 - 47 * G) - 128)),
      E = h * (1 + G / 16384 * (4096 + G * (G * (320 - 175 * G) - 768))) * (x - C * b * (q + C / 4 * (j * (2 * q * q - 1) - C / 6 * q * (4 * b * b - 3) * (4 * q * q - 3)))),
      I = Math.atan2(R * Math.sin(F), w * y - M * R * Math.cos(F)),
      O = Math.atan2(w * Math.sin(F), w * y * Math.cos(F) - M * R);
  return e.azimuth = I / n, e.distance = E, e.reverseAzimuth = O / n, e;
}

function v(n, i) {
  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "meters";
  if (!n || !i) throw new e("geodesic-distance:missing-parameters", "one or both input parameters are missing");
  if (!n.spatialReference || !i.spatialReference) throw new e("geodesic-distance:invalid-parameters", "one or both input points do not have a spatial reference");
  if (!n.spatialReference.equals(i.spatialReference)) throw new e("geodesic-distance:invalid-parameters", "spatial references of input parameters do not match");
  var a = n.spatialReference;
  if (!m(a)) throw new e("geodesic-distance:not-supported", "input geometry spatial reference is not supported");
  if (n.equals(i)) return {
    distance: 0,
    azimuth: 0,
    reverseAzimuth: 0
  };
  var r = {
    distance: null
  };
  return R(r, [n.x, n.y], [i.x, i.y], a), r.distance = t(r.distance, "meters", s), r.azimuth = u(r.azimuth), r.reverseAzimuth = u(r.reverseAzimuth), r;
}

function z(t, n, i) {
  if (!t || null == n || null == i) throw new e("point-from-distance:missing-parameters", "one or more input parameters are missing or undefined");
  if (i < 0 || i > 360) throw new e("point-from-distance:-of-bounds", "azimuth is restricted to angles between, and including, 0° to 360° degrees");
  if (!t.spatialReference) throw new e("point-from-distance:missing-spatial-reference", "the input point must have a spatial reference");
  var s = t.spatialReference;
  if (!m(s)) throw new e("geodesic-distance:not-supported", "input geometry spatial reference is not supported");
  var a = [0, 0];
  return y(a, [t.x, t.y], i, n, s), new o({
    x: a[0],
    y: a[1],
    spatialReference: s
  });
}

export { y as directGeodeticSolver, g as geodesicAreas, w as geodesicDensify, v as geodesicDistance, M as geodesicLengths, R as inverseGeodeticSolver, m as isSupported, z as pointFromDistance };